import React from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import { Typography, Link, Container, Snackbar } from '@material-ui/core';
import { Close as CloseIcon, Info as InfoIcon, ArrowBack as ArrowBackIcon } from '@material-ui/icons';
import useFetch from '../../../services/useFetch';
import { AppConfig } from '../../../config';
import { UserContext, AuthTokenContext } from '../../../app';
import './style.css';

function TryAPI(props) {
    const { location } = props;
    const fromDocs = Boolean(location?.state?.fromDocs);
    const routeBackLink = location?.state?.routeBackLink;
    const { currentUser } = React.useContext(UserContext);
    const { authToken, handleSaveAuthToken } = React.useContext(AuthTokenContext);
    const { PageName, tabname } = useParams();
    const ApiLink = PageName ? PageName : location;
    const [spec, setSpec] = React.useState(null);
    const [showSnackBar, setShowSnackBar] = React.useState(false);

    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    const {
        call: getApiKeyAPICall,
        data: getApiKeyAPIData,
        error: getApiKeyAPIError,
    } = useFetch(
        '/V5.0/DeveloperPortal/GetAPIKey',
        'POST',
        {},
        {},
        {
            userId: currentUser?.userId,
        },
        [],
        { callOnMount: false }
    );

    React.useEffect(() => {
        if (currentUser) {
            if (ApiLink === 'gettoken') {
                getApiKeyAPICall();
            } else if (authToken && ApiLink != 'gettoken') {
                handlePreFillAuthToken();
            } else {
                handleTryApiForLoggedInUser();
            }
        } else if (!currentUser && authToken && ApiLink != 'gettoken') {
            handlePreFillAuthToken();
        }
    }, [currentUser, authToken]);

    React.useEffect(() => {
        if (getApiKeyAPIData?.domainAPIKey) {
            handleGetTokenTryApiForLoggedInUser(getApiKeyAPIData.domainAPIKey);
        } else {
            handleTryApiForLoggedInUser();
        }
    }, [getApiKeyAPIData]);

    const handleTryApiForLoggedInUser = async () => {
        const file = await fetch(`${AppConfig.TryApiPath}${ApiLink}${'.json'}`).then((res) => res.json());
        if (authToken && ApiLink != 'gettoken') {
            await handlePreFillAuthToken();
        }
        else if (currentUser) {
            setSpec({ ...file, host: AppConfig.ApiBaseURL });
        }
    };

    const handleGetTokenTryApiForLoggedInUser = async (domainAPIKey) => {
        const file = await fetch(`${AppConfig.TryApiPath}${ApiLink}${'.json'}`).then((res) => res.json());
        if (authToken && ApiLink != 'gettoken') {
            await handlePreFillAuthToken();
        }
        else if (currentUser) {
            setSpec({
                ...file,
                host: AppConfig.ApiBaseURL,
                definitions: {
                    "SurePrep.API.Models.User": {
                        type: "object",
                        properties: {
                            UserName: {
                                type: "string"
                            },
                            Password: {
                                type: "string"
                            },
                            APIKey: {
                                type: "string",
                                default: domainAPIKey
                            }
                        }
                    }
                }
            });
        }
    };

    const handleResponseInterceptor = async (data) => {
        if (ApiLink === 'gettoken' && data?.obj?.Token) {
            await handleSaveAuthToken(data.obj.Token);
        }
        return data;
    };

    const handlePreFillAuthToken = async () => {
        let file = await fetch(`${AppConfig.TryApiPath}${ApiLink}${'.json'}`).then((res) => res.json());
        file = JSON.stringify(file);
        file = file.replace(`"name":"AuthToken",`, `"name":"AuthToken","default":"${authToken}",`);
        file = JSON.parse(file);
        setSpec({ ...file, host: AppConfig.ApiBaseURL });
        setShowSnackBar(true);
    };

    return (
        <Container className="swaggar-api">
            <Typography component="div" className="swaggar-back">
                {!isNaN(tabname) ? (
                    <Link
                        component={RouterLink}
                        to={{
                            pathname: (fromDocs && routeBackLink) ? `${routeBackLink}` : '/apiproducts',
                            search: null,
                            state: (fromDocs && routeBackLink) ? {} : { page: parseInt(tabname) },
                        }}
                    >
                        <ArrowBackIcon />
                    </Link>
                ) : (
                    <Link
                        component={RouterLink}
                        to={{
                            pathname: '/support',
                            search: null,
                            state: { page: 0 },
                        }}
                    >
                        <ArrowBackIcon />
                    </Link>
                )}
            </Typography>
            {spec ? (<>
                <SwaggerUI
                    spec={spec}
                    docExpansion="full"
                    responseInterceptor={handleResponseInterceptor}
                />
            </>) : (
                <SwaggerUI
                    url={`${AppConfig.TryApiPath}${ApiLink}${'.json'}`}
                    docExpansion="full"
                    responseInterceptor={handleResponseInterceptor}
                />
            )}
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                open={showSnackBar}
                autoHideDuration={6000}
                onClose={() => setShowSnackBar(false)}
            >
                <div className="snackbar-container">
                    <InfoIcon className="snackbar-info-icon" />
                    <span>The access token has been pre-filled.</span>
                    <CloseIcon className="snackbar-close-icon" onClick={() => setShowSnackBar(false)} />
                </div>
            </Snackbar>
        </Container>
    );
};

TryAPI.propTypes = {
    page: PropTypes.object,
};

export default TryAPI;
